/** @flow */
function hexToRgb(hex: string): [number, number, number] {
  const normalized = hex.replace('#', '');
  return [
    parseInt(normalized.substring(0, 2), 16),
    parseInt(normalized.substring(2, 4), 16),
    parseInt(normalized.substring(4, 6), 16),
  ];
}

function rgbToHex(rgb: [number, number, number]): string {
  return `#${rgb.map(channel => Math.round(channel).toString(16).padStart(2, '0')).join('')}`;
}

export function interpolateColor(minColor: string, maxColor: string, min: number, max: number, value: number): string {
  if (max <= min) {
    return minColor;
  }

  const ratio = Math.min(1, Math.max(0, (value - min) / (max - min)));
  const [minR, minG, minB] = hexToRgb(minColor);
  const [maxR, maxG, maxB] = hexToRgb(maxColor);

  return rgbToHex([
    minR + ((maxR - minR) * ratio),
    minG + ((maxG - minG) * ratio),
    minB + ((maxB - minB) * ratio),
  ]);
}

export default { interpolateColor };



// WEBPACK FOOTER //
// ./src/common/helpers/colorScale.js